module.exports = __webpack_public_path__ + "img/main_culture6.f2faeabb.png";